import { Outlet } from 'react-router';

import useDocumentTitle from '@/hooks/useDocumentTitle';

const ShipperSection = () => {
  useDocumentTitle({
    resourceTitle: 'Operadores logísticos',
    showTitle: 'Operador logístico {id}',
    editTitle: 'Editar operador logístico {id}',
    createTitle: 'Nuevo operador logístico',
  });

  return (
    <div className="ShipperSection MainSection">
      <Outlet />
    </div>
  );
};

export default ShipperSection;
